export const platformsMock = ['Steam', 'Playstation', 'Xbox', 'Nintendo'];
